import React from 'react';
import Hero from '../../components/Hero/Hero';
import Ticker from '../../components/Ticker/Ticker';
import WaveDivider from '../../components/WaveDivider/WaveDivider';
import VisionMission from '../../components/VisionMission/VisionMission';
import SDGs from '../../components/SDGs/SDGs';
import About from '../../components/About/About';
import FocusAreas from '../../components/FocusAreas/FocusAreas';
import AdvisoryBoard from '../../components/AdvisoryBoard/AdvisoryBoard';
import Footer from '../../components/Footer/Footer';

function Home() {
  return (
    <>
      <Hero />
      <Ticker />
      <WaveDivider variant="dark-to-light" size="tall" />
      <VisionMission />
      <WaveDivider variant="light-to-sand" />
      <SDGs />
      <WaveDivider variant="sand-to-light" />
      <About />
      <WaveDivider variant="light-to-dark" size="xl" />
      <FocusAreas />
      <WaveDivider variant="dark-to-sand" size="xl" />
      <AdvisoryBoard />
      <WaveDivider variant="sand-to-dark" size="xl" />
      <Footer />
    </>
  );
}

export default Home;
